<template>
  <component :is="type" :to="to" :class="['dea-links', className]" v-on="$listeners">
    <span :class="labelClassCombined">
      <slot />
    </span>
    <slot name="icon">
      <span
        v-if="icon !== '' && icon !== undefined"
        class="icon dea-links__icon"
        :class="[getIcon(icon), iconClass]"
        :aria-label="`icona ${icon}`"
      >
      </span>
    </slot>
  </component>
</template>

<script>
/**
 * I collegamenti sono utilizzati principalmente come elemento di navigazione verso altre pagine, informazioni aggiuntive o azioni specifiche.<br>Di questo elemento è possibile gestire: il colore delle linea di fondo, la presenza o meno dell'icona e la sua posizione a destra o sinistra della label.
 */
export default {
  name: "Links",
  props: {
    type: {
      type: String,
      default: "a",
    },
    icon: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: "",
    },
    to: {
      type: Object,
      default: null,
    },
  },
  computed: {
    labelClassCombined() {
      return `dea-links__label ${this.labelClass}`;
    },
  },
  methods: {
    getIcon(icon) {
      return `dea-ico-${icon}`;
    },
  },
};
</script>
